<template>
    <div>
        <div class="modal fade" id="modalSignUp">
            <div class="modal-dialog">
                <div class="modal-content no-r "><a href="#" data-dismiss="modal" aria-label="Close" class="paper-nav-toggle active"><i></i></a>
                    <div class="modal-body no-p">
                        <div class="text-center p-20 p-b-0">
                            <!-- <img class="w-30" :src="url + '/frontend/img/comfy/logo-light.png'" alt=""> -->
                            <p class="p-t-20 m-0">Es hora de un masaje, crea tu cuenta y disfruta de todos nuestros beneficios</p>
                        </div>
                        <div class="p-20 p-2">

                            <form class="form-horizontal login" method="post" @submit="postSignup" novalidate="true">
                                <div class="form-group">
                                    <i class="icon-user-circle"></i>
                                    <label>Escribe tu nombre (requerido)</label>
                                    <el-input placeholder="Escribe tu nombre" autocomplete="on" name="name" v-model="fillSignupUsuario.cName" clearable></el-input>
                                    <div class="mb-3 text-danger" v-if="errors['cName']">
                                        {{ errors['cName'][0] }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <i class="icon-envelope-o"></i>
                                    <label>Escribe tu correo (requerido)</label>
                                    <el-input placeholder="@" autocomplete="on" name="email" v-model="fillSignupUsuario.cEmail" clearable @input="reglaCorreo"></el-input>
                                    <div class="mb-3 text-danger" v-if="errors['cEmail']">
                                        {{ errors['cEmail'][0] }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <i class="icon-globe"></i>
                                    <label>Elige la ciudad en donde te encuentras</label>
                                    <el-select class="w-100" v-model="fillSignupUsuario.cCiudad" clearable placeholder="Ciudad:" size="large">
                                        <el-option
                                            v-for="item in cities"
                                            :key="item.id"
                                            :label="item.microciudad"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                    <div class="mb-3 text-danger" v-if="errors['cCiudad']">
                                        {{ errors['cCiudad'][0] }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <i class="icon-phone"></i>
                                    <label>Escribe tu número celular (requerido)</label>
                                    <VuePhoneNumberInput v-model="phoneNumber" default-country-code="CO" :preferred-countries="countriesList" :translations="translations" @update="updateCelular" />
                                    <div class="mb-3 text-danger" v-if="errors['celular']">
                                        {{ errors['celular'][0] }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <i class="icon-key4"></i>
                                    <label>Escribe una clave segura (mínimo 8 carácteres, requerido)</label>
                                    <el-input placeholder="Esribe tu contraseña" minlength="8" v-model="fillSignupUsuario.cPassword" show-password></el-input>
                                    <div class="mb-3 text-danger" v-if="errors['cPassword']">
                                        {{ errors['cPassword'][0] }}
                                    </div>
                                </div>
                                <div class="form-check registro-cliente">
                                    <el-checkbox v-model="fillSignupUsuario.aceptoPoliticas">Acepto los <a :href="url + '/terminos-y-condiciones'" target="_blank">Términos y Condiciones</a> del servicio y <a :href="url + '/proteccion-datos'" target="_blank">Políticas de Protección de Datos Personales</a>.</el-checkbox>
                                    <div class="mb-3 text-danger" v-if="errors['aceptoPoliticas']">
                                        {{ errors['aceptoPoliticas'][0] }}
                                    </div>
                                </div>
                                <div class="mb-3" v-if="error">
                                    <div class="text-danger" v-for="(item, items) in mensajeError">
                                        {{ item }}
                                    </div>
                                </div>
                                <div class="row b-3">
                                    <div class="col-12">
                                        <button type="submit" v-loading.fullscreen.lock="fullscreenLoading" class="btn btn-primary comfy btn-sm btn-block mb-3 cursor-pointer">Crear cuenta con mi correo</button>
                                    </div>
                                </div>
                            </form>

                            <div class="form-group d-flow-root">
                                <small class="forget-pass float-right mb-3"><a data-toggle="modal" data-target="#modalLogin" data-dismiss="modal" href="#">Ya tengo una cuenta creada en Comfy</a></small>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.modal-body .country-selector__label, .modal-body .input-tel__label{
    top: -7px !important;
}
</style>

<script>
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';
    Vue.component('VuePhoneNumberInput', VuePhoneNumberInput);
    export default {
        props: ['url'],
        data() {
            return {
                fillSignupUsuario: {
                    'cName': '',
                    'cEmail': '',
                    'cPassword': '',
                    'cPhone': '',
                    'aceptoPoliticas': false,
                    'indicativo': '',
                    'celular': '',
                    'countrycode': '',
                    'cCiudad': 1,
                },
                error: 0,
                errors: [],
                mensajeError: [],
                fullscreenLoading: false,
                type: '',
                cliente: [],
                phoneNumber: null,
                datosPhoneNumber: [],
                countriesList: ['CO', 'ES', 'US'],
                translations: {
                    countrySelectorLabel: 'Indicativo',
                    countrySelectorError: 'Debes elegir país',
                    phoneNumberLabel: 'Número de teléfono',
                    example: 'Ejemplo:'
                },
                cities: [],
            }
        },
        computed: {

        },
        methods: {
            reglaCorreo(val){
                this.fillSignupUsuario.cEmail = val.replace(/[&\/\\#, +()$~%'":*?<>{}\s]/g, '');
            },
            // reglaCelular(val){
            //     this.fillSignupUsuario.cPhone = val.replace(/[^0-9]/g, '');
            // },
            validarDatosUsuario(){
                this.error = 0
                this.mensajeError = []
                if(!this.fillSignupUsuario.cName){
                    this.mensajeError.push('Debes escribir tu nombre.')
                }
                if(!this.fillSignupUsuario.cCiudad){
                    this.mensajeError.push('Debes elegir una ciudd.')
                }
                if(!this.fillSignupUsuario.cEmail){
                    this.mensajeError.push('El correo es un campo obligatorio.')
                }else if (!this.validEmail(this.fillSignupUsuario.cEmail)){
                    this.mensajeError.push('El correo electrónico debe ser válido.')
                }
                if(!this.fillSignupUsuario.cPhone){
                    this.mensajeError.push('El celular es un campo obligatorio.')
                }else if(!this.validCelular(this.fillSignupUsuario.cPhone)){
                    this.mensajeError.push('El celular debe ser de 10 dígitos.')
                }
                if(!this.fillSignupUsuario.cPassword){
                    this.mensajeError.push('La contraseña es un campo obligatorio.')
                }else if(this.fillSignupUsuario.cPassword.length < 8){
                    this.mensajeError.push('La contraseña debe ser de al menos 8 carácteres.')
                }
                if(!this.fillSignupUsuario.aceptoPoliticas){
                    this.mensajeError.push('Debes aceptar nuestros términos y condiciones de servicio para poder ingresar.')
                }
                if(this.mensajeError.length){
                    this.error = 1
                }
                this.fullscreenLoading = false
                return this.error
            },
            validEmail: function (email) {
                var testMail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return testMail.test(email);
            },
            validCelular: function () {
                if(this.datosPhoneNumber.isValid){
                    return true
                }else{
                    return false
                }
            },
            updateCelular(payload) {
                this.datosPhoneNumber = payload
                if(payload.isValid){
                    this.fillSignupUsuario.cPhone = payload.e164
                    this.fillSignupUsuario.indicativo = payload.countryCallingCode
                    this.fillSignupUsuario.celular = payload.nationalNumber
                    this.fillSignupUsuario.countrycode = payload.countryCode
                }else{
                    this.fillSignupUsuario.cPhone = ''
                }
            },
            postSignup(e){
                e.preventDefault();
                let self = this;
                this.mensajeError = []
                this.fullscreenLoading = true
                if(this.validarDatosUsuario()){
                    return
                }
                var url = '/authenticate/register'
                let params = this.fillSignupUsuario
                axios.post(url, params)
                .then(response => {
                    this.fullscreenLoading = false
                    this.cliente = response.data.user
                    this.type = response.data.type
                    this.fillSignupUsuario.cEmail = ''
                    this.fillSignupUsuario.cPassword = ''
                    $('#modalSignUp').modal('hide')
                    location.reload()
                }).catch(function (e) {
                    self.fullscreenLoading = false;
                    self.errors = e.response.data.errors;
                })
            },
            getCities(){
                var url = '/get-cities'
                axios.post(url).then(response => {
                    this.cities = response.data.cities
                })
            },
        },
        mounted() {
            // console.log('--- componente modal registro ---')
            this.getCities()
        }
    }
</script>
